/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

const prefix = (type) => `st/admin/companies/${type}`;

export const LIST_LOAD_START = prefix('LIST_LOAD_START');
export const LIST_LOAD_SUCCESS = prefix('LIST_LOAD_SUCCESS');
export const LIST_LOAD_FAILED = prefix('LIST_LOAD_FAILED');

export const LOAD_START = prefix('LOAD_START');
export const LOAD_SUCCESS = prefix('LOAD_SUCCESS');
export const LOAD_FAILED = prefix('LOAD_FAILED');

export const CREATE_START = prefix('CREATE_START');
export const CREATE_SUCCESS = prefix('CREATE_SUCCESS');
export const CREATE_FAILED = prefix('CREATE_FAILED');

export const UPDATE_START = prefix('UPDATE_START');
export const UPDATE_SUCCESS = prefix('UPDATE_SUCCESS');
export const UPDATE_FAILED = prefix('UPDATE_FAILED');

export const ADD_SITE_START = prefix('ADD_SITE_START');
export const ADD_SITE_SUCCESS = prefix('ADD_SITE_SUCCESS');
export const ADD_SITE_FAILED = prefix('ADD_SITE_FAILED');

export const REMOVE_SITE_START = prefix('REMOVE_SITE_START');
export const REMOVE_SITE_SUCCESS = prefix('REMOVE_SITE_SUCCESS');
export const REMOVE_SITE_FAILED = prefix('REMOVE_SITE_FAILED');

export const CLEAR = prefix('CLEAR');
export const CLEAR_SINGLE = prefix('CLEAR_SINGLE');
